var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x33_0",
    enableBackground: "new 0 0 62 62",
    height: 512,
    viewBox: "0 0 62 62",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m61 2v30c0 .55-.45 1-1 1h-9-11c-.55 0-1-.45-1-1v-7-23c0-.55.45-1 1-1h20c.55 0 1 .45 1 1z",
    fill: "#e6e9ed"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m43 5h14v4h-14z",
    fill: "#69d6f4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m39 41v-3c0-.55-.45-1-1-1h-9v-11c0-.55.45-1 1-1h9v7c0 .55.45 1 1 1h11v23c0 .55-.45 1-1 1h-11z",
    fill: "#ffeaa7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m27 9v4h-1.09c-.67 0-1.25.43-1.51 1.05 0 0-.01.01-.01.02-.26.62-.15 1.34.33 1.82l.77.77-2.83 2.83-.77-.77c-.48-.48-1.2-.59-1.82-.33-.01 0-.02.01-.02.01-.62.26-1.05.84-1.05 1.51v1.09h-4v-1.09c0-.67-.43-1.25-1.05-1.51 0 0-.01-.01-.02-.01-.62-.26-1.34-.15-1.82.33l-.77.77-2.83-2.83.77-.77c.48-.48.59-1.2.33-1.82 0-.01-.01-.02-.01-.02-.26-.62-.84-1.05-1.51-1.05h-1.09v-4h1.09c.67 0 1.25-.43 1.51-1.05 0 0 .01-.01.01-.02.26-.62.15-1.34-.33-1.82l-.77-.77 2.83-2.83.77.77c.48.48 1.2.59 1.82.33.01 0 .02-.01.02-.01.62-.26 1.05-.84 1.05-1.51v-1.09h4v1.09c0 .67.43 1.25 1.05 1.51 0 0 .01.01.02.01.62.26 1.34.15 1.82-.33l.77-.77 2.83 2.83-.77.77c-.48.48-.59 1.2-.33 1.82 0 .01.01.02.01.02.26.62.84 1.05 1.51 1.05zm-6 2c0-2.21-1.79-4-4-4s-4 1.79-4 4 1.79 4 4 4 4-1.79 4-4z",
    fill: "#fcd770"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m39 57v3c0 .55-.45 1-1 1h-36c-.55 0-1-.45-1-1v-19h38z",
    fill: "#e6e9ed"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m2 33h14c.55 0 1 .45 1 1v3h12 9c.55 0 1 .45 1 1v3h-38v-7c0-.55.45-1 1-1z",
    fill: "#ff826e"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m17 16c2.757 0 5-2.243 5-5s-2.243-5-5-5-5 2.243-5 5 2.243 5 5 5zm0-8c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.687 14.453c.111.269.069.547-.11.726l-1.481 1.481 4.244 4.244 1.48-1.48c.18-.18.459-.221.75-.101.265.11.43.335.43.588v2.089h6v-2.088c0-.253.165-.479.453-.598.269-.113.546-.07.727.11l1.48 1.48 4.244-4.244-1.481-1.48c-.179-.18-.221-.458-.1-.75.108-.261.339-.43.588-.43h2.089v-6h-2.089c-.249 0-.479-.168-.598-.453-.111-.269-.069-.547.11-.726l1.481-1.481-4.244-4.245-1.48 1.481c-.18.181-.458.221-.75.101-.265-.11-.43-.336-.43-.589v-2.088h-6v2.088c0 .253-.165.479-.453.598-.27.112-.547.069-.727-.109l-1.48-1.481-4.244 4.244 1.481 1.48c.179.18.221.458.1.75-.109.262-.339.43-.588.43h-2.089v6h2.089c.249 0 .479.168.598.453zm-.687-4.453h.089c1.062 0 2.019-.654 2.443-1.685.423-1.015.211-2.157-.541-2.909l-.067-.066 1.416-1.416.066.067c.754.752 1.896.965 2.928.533 1.013-.418 1.666-1.374 1.666-2.436v-.088h2v.088c0 1.062.653 2.018 1.684 2.444 1.014.422 2.156.211 2.91-.542l.066-.066 1.416 1.416-.067.067c-.752.751-.964 1.893-.533 2.927.417 1.012 1.374 1.666 2.435 1.666h.089v2h-.089c-1.062 0-2.019.654-2.443 1.685-.423 1.015-.211 2.157.541 2.909l.067.066-1.416 1.416-.066-.067c-.754-.752-1.896-.965-2.928-.533-1.013.418-1.666 1.374-1.666 2.436v.088h-2v-.088c0-1.062-.653-2.018-1.684-2.444-1.013-.423-2.156-.211-2.91.542l-.066.066-1.416-1.416.067-.067c.752-.751.964-1.893.533-2.927-.417-1.012-1.374-1.666-2.435-1.666h-.089z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 24h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16 28h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 10h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34 10h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8 36h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 36h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4 36h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60 0h-20c-1.103 0-2 .897-2 2v22h-8c-1.103 0-2 .897-2 2v10h-10v-2c0-1.103-.897-2-2-2h-14c-1.103 0-2 .897-2 2v26c0 1.103.897 2 2 2h36c1.103 0 2-.897 2-2v-2h10c1.103 0 2-.897 2-2v-22h8c1.103 0 2-.897 2-2v-30c0-1.103-.897-2-2-2zm-44 34v4h22v2h-36v-6zm-14 26v-18h36v18zm48-4h-10v-18c0-1.103-.897-2-2-2h-8v-10h8v6c0 1.103.897 2 2 2h10zm-10-24v-30h20l.001 30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 10h16v-6h-16zm2-4h12v2h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 16h16v2h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 12h16v2h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 20h16v2h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 24h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 24h12v2h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 28h2v2h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 28h12v2h-12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 28h4v2h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 32h4v2h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 36h6v2h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 40h6v2h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 44h6v2h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 48h6v2h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42 52h6v2h-6z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.17d491fd7b7e4042d108fc554a85ef2a.svg";
export { ForwardRef as ReactComponent };